import { FunctionComponent } from 'react'
import styles from './CALDHome.module.scss'
import Title from '@/components/_custom/Title/title'
import { useTranslation } from 'react-i18next'
import { NavigateFunction, useNavigate } from 'react-router-dom'
import { useAuth } from '@/modules/context/AuthContext'
import LogoutIcon from '@mui/icons-material/ExitToApp'
import CachedIcon from '@mui/icons-material/Cached'
import { removeServiceWorker } from '@/modules/utils/serviceWorker'
import SettingsIcon from '@mui/icons-material/Settings'
import { Assignment, Groups, ListAlt, Restaurant } from '@mui/icons-material'
import FamiliesIcon from '@mui/icons-material/SupervisedUserCircle'
import GroupIcon from '@mui/icons-material/HolidayVillage'
import HomeCase from '../HomeCase/homeCase'

interface CALDHomeMobileProps {
    backendVersion: string
    frontendVersion: string
    setDialogSupportOpen: (open: boolean) => void
}

const CALDHomeMobile: FunctionComponent<CALDHomeMobileProps> = ({
    backendVersion,
    frontendVersion,
    setDialogSupportOpen
}: CALDHomeMobileProps) => {
    const { t } = useTranslation()

    const { logout } = useAuth()

    const navigate: NavigateFunction = useNavigate()

    return (
        <div className={styles.PagePosition}>
            <div className={styles.HomePlacement}>
                <div className={styles.CaseContainer}>
                    <HomeCase
                        text={t('families')}
                        icon={<FamiliesIcon className={styles.CaseIcon} />}
                        onClick={(): void | Promise<void> => navigate('/adults')}
                    />
                    <HomeCase
                        text={t('staff')}
                        icon={<Groups className={styles.CaseIcon} />}
                        onClick={(): void | Promise<void> => navigate('/staff')}
                    />
                </div>
                <div className={styles.CaseContainer}>
                    <HomeCase
                        text={t('tasksAndNotes')}
                        icon={<ListAlt className={styles.CaseIcon} />}
                        onClick={(): void | Promise<void> => navigate('/taskNote')}
                    />
                    <HomeCase
                        text={t('suggestions')}
                        icon={<Assignment className={styles.CaseIcon} />}
                        onClick={(): void | Promise<void> => navigate('/suggest')}
                    />
                </div>
                <div className={styles.CaseContainer}>
                    <HomeCase
                        text={t('meal')}
                        icon={<Restaurant className={styles.CaseIcon} />}
                        onClick={(): void | Promise<void> => navigate('/meal')}
                    />
                    <HomeCase
                        text={t('group')}
                        icon={<GroupIcon className={styles.CaseIcon} />}
                        onClick={(): void | Promise<void> => navigate('/group')}
                    />
                </div>
            </div>
            <div className={styles.HomePlacement}>
                <Title text={`${t('settings')} - CALD`} className={styles.Title} />
                <div className={styles.CaseContainer}>
                    <HomeCase
                        text={t('settings')}
                        icon={<SettingsIcon className={styles.CaseIcon} />}
                        onClick={(): void | Promise<void> => navigate('/settings')}
                    />
                </div>
                <div className={styles.CaseContainer}>
                    <HomeCase
                        text={t('refresh')}
                        icon={<CachedIcon className={styles.CaseIcon} />}
                        onClick={removeServiceWorker}
                    />
                    <HomeCase text={t('logout')} icon={<LogoutIcon className={styles.CaseIcon} />} onClick={logout} />
                </div>
            </div>
            <div className={styles.Version}>
                <a onClick={() => setDialogSupportOpen(true)}>
                    V{backendVersion}/{frontendVersion}
                </a>
            </div>
        </div>
    )
}

export default CALDHomeMobile
